<template>
  <div class="c-tab_wrapper">
    <div
      class="c-tab_wrapper-items"
      v-for="tab in tabList"
      :key="tab.id"
      @click="tabClik(tab)"
      :class="{'c-tab_wrapper-itemsActive': tab.id===nowId}"
    >
       {{tab.name}}
    </div>
  </div>
</template>

<script>
  export default {
    props:{
      tabList:{
        type:Array,
        default:()=>{
          return [
            {
              name:"全部",
              id:999
            },{
              name:"收入",
              id:1
            },{
              name:"支出",
              id:2
            },{
              name:"内部转账",
              id:0
            }
          ]
        }
      }
    },
    data() {
      return {
        nowId:999
      }
    },
    methods:{
      tabClik(tab) {
        this.nowId = tab.id;
        this.$emit("tabClick",tab.id)
      }
    }
  }
</script>

<style lang='less' scoped>
  .c-tab_wrapper {
    display: flex;
    align-items: center;
    &-items {
      width: 89px;
      padding: 5px 0;
      text-align: center;
      background-color: #F7F7F7;
      color: #269D7B;
      cursor: pointer;
      font-weight: 400;
      &:hover {
        background-color: #FBFBFB;
      }
      &:first-child {
        border-radius: 4px 0px 0px 0px;
      }
    }
    &-itemsActive {
      background-color: #269D7B;
      color: #fff;
      border-radius: 4px 4px 0px 0px !important;
      &:hover {
       background-color: #269D7B;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/c-query-table/c-table-tab.vue